/** Category names that only differ by case, spacing or invisible characters are the same category. */
export const normCat = (value) =>
  String(value ?? "")
    .replace(/[\u200b-\u200f\ufeff\u00ad]/g, "")
    .normalize("NFKC")
    .replace(/\u00a0/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const uniqueCats = (values) => {
  const seen = new Map();
  for (const v of values) {
    const key = normCat(v);
    if (key && !seen.has(key)) seen.set(key, String(v).trim());
  }
  return [...seen.values()];
};

export const sameCat = (a, b) => normCat(a) === normCat(b);
